"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const encodeurl_1 = __importDefault(require("encodeurl"));
const query_string_1 = __importDefault(require("query-string"));
const constants_1 = require("./constants");
const SYMBOLS = __importStar(require("./symbols"));
exports.isRequired = (part) => SYMBOLS.REQUIRED.indexOf(part.type) >= 0;
exports.serializeValue = (part, value) => {
    if (part.type === SYMBOLS.REQUIRED_STRING && typeof value === 'string') {
        return value;
    }
    if (part.type === SYMBOLS.OPTIONAL_STRING &&
        (typeof value === 'string' || typeof value === 'undefined')) {
        return value;
    }
    if (part.type === SYMBOLS.REQUIRED_NUMBER && typeof value === 'string') {
        return parseFloat(value);
    }
    if (part.type === SYMBOLS.OPTIONAL_NUMBER) {
        if (typeof value === 'string') {
            return parseFloat(value);
        }
        if (typeof value === 'undefined') {
            return value;
        }
    }
    if (part.type === SYMBOLS.REQUIRED_BOOLEAN && typeof value === 'string') {
        if (value === 'true') {
            return true;
        }
        if (value === 'false') {
            return false;
        }
    }
    if (part.type === SYMBOLS.OPTIONAL_BOOLEAN) {
        if (value === 'true') {
            return true;
        }
        if (value === 'false') {
            return false;
        }
        if (typeof value === 'undefined') {
            return value;
        }
    }
    if (part.type === SYMBOLS.REQUIRED_STRING_ARRAY &&
        (typeof value === 'string' || Array.isArray(value))) {
        return [].concat(value);
    }
    if (part.type === SYMBOLS.OPTIONAL_STRING_ARRAY) {
        if (typeof value === 'string' || Array.isArray(value)) {
            return [].concat(value);
        }
        if (typeof value === 'undefined') {
            return value;
        }
    }
    if (part.type === SYMBOLS.REQUIRED_NUMBER_ARRAY &&
        (typeof value === 'string' || Array.isArray(value))) {
        return []
            .concat(value)
            .map(sub => parseFloat(sub));
    }
    if (part.type === SYMBOLS.OPTIONAL_NUMBER_ARRAY) {
        if (typeof value === 'string' || Array.isArray(value)) {
            return []
                .concat(value)
                .map(sub => parseFloat(sub));
        }
        if (typeof value === 'undefined') {
            return value;
        }
    }
    if (part.type === SYMBOLS.REQUIRED_BOOLEAN_ARRAY &&
        (typeof value === 'string' || Array.isArray(value))) {
        return [].concat(value).map(sub => {
            if (sub === 'true') {
                return true;
            }
            if (sub === 'false') {
                return false;
            }
            throw new Error(`Invalid value for part "${part.name}" - ${value}`);
        });
    }
    if (part.type === SYMBOLS.OPTIONAL_BOOLEAN_ARRAY) {
        if (typeof value === 'string' || Array.isArray(value)) {
            return [].concat(value).map(sub => {
                if (sub === 'true') {
                    return true;
                }
                if (sub === 'false') {
                    return false;
                }
                throw new Error(`Invalid value for part "${part.name}" - ${value}`);
            });
        }
        if (typeof value === 'undefined') {
            return value;
        }
    }
    throw new Error(`Invalid value for part "${part.name}" - ${value}`);
};
exports.serializeURLParams = (params, schema) => {
    const serializedParams = {};
    schema.forEach(part => {
        if (typeof part !== 'string') {
            const value = params[part.name];
            if (exports.isRequired(part) && typeof value === 'undefined') {
                throw new Error(`Required URL param "${part.name}" was undefined`);
            }
            if (value === null) {
                throw new Error(`Invalid null value for URL param "${part.name}"`);
            }
            serializedParams[part.name] = exports.serializeValue(part, value);
        }
    });
    return serializedParams;
};
exports.serializeQueryParams = (params, schema) => {
    const serializedParams = {};
    schema.forEach(part => {
        const value = params[part.name];
        if (exports.isRequired(part) && typeof value === 'undefined') {
            throw new Error(`Required query param "${part.name}" was undefined`);
        }
        if (value === null) {
            throw new Error(`Invalid null value for URL param "${part.name}"`);
        }
        serializedParams[part.name] = exports.serializeValue(part, value);
    });
    return serializedParams;
};
exports.constructPath = (urlParams, urlParamsSchema, options) => {
    const { trailingSlash, protocol, encode, normalize } = options;
    let url = urlParamsSchema
        .map(part => {
        if (typeof part === 'string') {
            return part;
        }
        const value = urlParams[part.name];
        if (typeof value === 'undefined') {
            if (exports.isRequired(part)) {
                throw new Error(`Required URL param "${part.name}" was not provided`);
            }
            return '';
        }
        return `${value}`;
    })
        .join('/');
    if (normalize === true) {
        url = url.replace(constants_1.MATCHES_MULTIPLE_SLASHES, '/');
    }
    if (trailingSlash === true) {
        url = url.replace(constants_1.MATCHES_MAYBE_TRAILING_SLASH, '/');
    }
    if (trailingSlash === false) {
        url = url.replace(constants_1.MATCHES_MAYBE_TRAILING_SLASH, '');
    }
    if (typeof protocol === 'string') {
        url = url.replace(constants_1.MATCHES_MAYBE_PROTOCOL, protocol);
    }
    if (protocol === false) {
        url = url.replace(constants_1.MATCHES_MAYBE_PROTOCOL, '');
    }
    if (encode === true) {
        url = encodeurl_1.default(url);
    }
    return url;
};
exports.constructQuery = (queryParams, queryParamsShema, options) => {
    const { encode, queryArrayFormat, queryArrayFormatSeparator } = options;
    const filteredQueryParams = {};
    queryParamsShema.forEach(part => {
        const value = queryParams[part.name];
        if (typeof value !== 'undefined') {
            filteredQueryParams[part.name] = value;
        }
        else if (exports.isRequired(part)) {
            throw new Error(`Required query param "${part.name}" was not provided`);
        }
    });
    return query_string_1.default.stringify(filteredQueryParams, {
        encode,
        arrayFormat: queryArrayFormat,
        arrayFormatSeparator: queryArrayFormatSeparator,
    });
};
//# sourceMappingURL=utils.js.map